import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WindowLoaderService {

  private toHide = true;

  constructor() { }

  show(): void {
    if (this.toHide)
      this.toHide = false;
  }

  hide(): void {
    if (!this.toHide)
      this.toHide = true;
  }

  blockWithLoader<T>(request: Observable<T>): Observable<T> {
    const obs = new Observable<T>(observer => {
      this.show();
      request.subscribe(
        (ret) => { observer.next(ret); },
        (error) => { this.hide(); observer.error(error); },
        () => { this.hide(); observer.complete();}

      )
    });

    return obs;
  }
}
